var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function IssuesChart(el) {
  var $el = $(el),
      $chart = $el.find('#issues'),
      $chartWidth = $chart.width(),
      $chartFilter = $el.find('.chart-filter');

  $chart.find('li').each(function() {
    var $style = {
      'width': ($(this).attr('data-val') * $chartWidth) / 60 + 'px'
    };
    $(this).find('.chart-bar').css($style).addClass('visible');
  });

  $chartFilter.on('click', 'a', function(e) {
    e.preventDefault();
    $(this).toggleClass('selected');
    var $selected = $chartFilter.find('.selected');
    if ($selected.length) {
      var $filters = [];
      $selected.each(function() {
        $filters.push($(this).attr('data-stakeholder'));
      });
      $chart.find('li').each(function() {
        if ($filters.indexOf($(this).attr('data-stakeholder')) !== -1) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    } else {
      $chart.find('li').show();
    }
  });
}

module.exports = IssuesChart;
